import SEO from "../../../components/seo.jsx"
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import HeroImg1 from "../../../assets/ht-cost-1.png";
import HeroImg2 from "../../../assets/ht-cost-2.png";
import HeroImg3 from "../../../assets/ht-cost-3.png";
import HeroImg4 from "../../../assets/ht-cost-4.png";

gsap.registerPlugin(ScrollTrigger);
const cinzel = { fontFamily: "'Cinzel', serif" };

const heroSlides = [HeroImg1, HeroImg2, HeroImg3, HeroImg4];

const PAGE = {
  hero: {
    eyebrow: "HT Pune",
    heading: "Hair Transplant Cost in Pune",
    sub: "Transparent pricing, world-class quality and affordable options everything you need to plan your hair restoration journey in Pune.",
  },

  breadcrumb: [
    { label: "Home", href: "/" },
    { label: "HT Pune", href: null },
    { label: "Hair Transplant Cost in Pune", href: null },
  ],

  /* ── SECTION 1 What is Hair Transplant ── */
  whatIs: {
    eyebrow: "Overview",
    heading: "What is Hair Transplant in Pune?",
    paragraphs: [
      "Hair transplant in Pune is a cosmetic surgical procedure designed to address hair loss and baldness. The process involves harvesting hair follicles from donor areas, often the back of the scalp, and then implanting them into areas with thinning or no hair. Skilled surgeons perform this procedure using advanced techniques like Sapphire FUE or DHI. India has gained recognition as a hub for hair transplants due to its affordable costs, experienced medical professionals and modern clinics, attracting individuals seeking effective solutions to restore their hair and confidence.",
      "Discover premier hair transplant solutions at Clinique Internationale, Pune. Our esteemed surgeons employ cutting-edge hair transplant techniques to artfully restore your hair, ensuring seamless, natural outcomes. With a commitment to excellence and a convenient Pune location, we provide the ideal destination for transforming your hair and confidence.",
    ],
    stats: [
      { val: "₹40K+", sub: "Starting cost per procedure" },
      { val: "98.5%", sub: "Success rate" },
      { val: "₹30–₹50", sub: "Cost per graft" },
      { val: "4", sub: "Clinique centre locations" },
    ],
  },

  /* ── SECTION 2 City-wise cost table ── */
  cityTable: {
    eyebrow: "Pricing",
    heading: "Best Hair Transplant Cost in Pune",
    intro: [
      "The cost of a hair transplant in Pune varies depending on several factors, including the technique chosen (FUE or FUT), the extent of hair loss, and the reputation of the clinic. On average, prices can range from around ₹40,000 ($500) to ₹2,50,000 ($2,500).",
      "Follicular Unit Transplantation (FUT) is typically more expensive than Follicular Unit Extraction (FUE), with the cost per graft ranging from ₹40 to ₹100 ($0.5 to $1.2 USD) for FUT and ₹40 to ₹80 ($0.5 to $1 USD) for FUE. Below is an overview of the average cost associated with hair transplant procedures across major cities in India.",
    ],
    heads: ["Major Cities", "Average Hair Transplant Price List"],
    rows: [
      { city: "Mumbai",    cost: "₹50,000 to ₹2,00,000",  per: "30–50 rupees per graft" },
      { city: "Bangalore", cost: "₹70,000 to ₹3,00,000",  per: "30–50 rupees per graft" },
      { city: "Chennai",   cost: "₹30,000 to ₹90,000",    per: "30–35 rupees per graft" },
      { city: "Delhi",     cost: "₹80,000 to ₹1,20,000",  per: "35–40 rupees per graft" },
      { city: "Nagpur",    cost: "₹65,000 to ₹90,000",    per: "20–35 rupees per graft" },
      { city: "Hyderabad", cost: "₹50,000 to ₹1,00,000",  per: "25–45 rupees per graft" },
      { city: "Pune",      cost: "₹60,000 to ₹2,50,000",  per: "30–50 rupees per graft" },
      { city: "Kolkata",   cost: "₹75,000 to ₹1,00,000",  per: "40–45 rupees per graft" },
    ],
  },

  /* ── SECTION 3 Factors ── */
  factors: {
    eyebrow: "Key Considerations",
    heading: "Factors Influencing Hair Transplant Cost in Pune",
    intro: "Hair transplant cost is influenced by a multitude of variables that must be taken into consideration. We pride ourselves on offering transparency and clarity when it comes to our pricing structure, allowing our clients to plan effectively for their hair transplant journey. Let's explore the key factors that contribute to the cost of a hair transplant in Pune.",
    list: [
      {
        num: "01",
        title: "Experience and Reputation of the Surgeon",
        desc: "A highly experienced, qualified and reputed surgeon with a proven track record will typically charge more for their services as he has developed the art of hair restoration over a period of years. It is said that a surgeon usually requires minimum 10 years of experience to develop this fine skill of hair surgeries.",
      },
      {
        num: "02",
        title: "Type of Hair Transplant Procedure Performed",
        desc: "A surgeon usually charges more for FUT technique as it is a surgical procedure done only with the surgeon's hands. FUE is in general slightly cheaper compared to FUT, but it depends from clinic to clinic and surgeon to surgeon.",
      },
      {
        num: "03",
        title: "Number of Grafts Required",
        desc: "The number of grafts needed for the transplant directly affects the cost. Grafts are units of hair follicles that are transplanted. The higher the number of grafts required, the more intricate and time-consuming the procedure, which influences the cost accordingly.",
      },
      {
        num: "04",
        title: "Expertise of the Medical Team",
        desc: "The expertise and reputation of the medical team performing the hair transplant play a significant role in cost determination. Highly experienced surgeons and skilled medical staff often command higher fees due to their proven track record of successful outcomes.",
      },
      {
        num: "05",
        title: "Location of the Clinic",
        desc: "The geographical location of the clinic is a contributing factor. Metros and urban centres may have higher costs due to increased overheads, while clinics in smaller towns might offer more competitive pricing.",
      },
      {
        num: "06",
        title: "Clinic Facilities and Amenities",
        desc: "The facilities and amenities offered by the clinic can also impact the cost. Clinics that offer more luxurious amenities like five-star hotel stays, airport transfers, etc. may charge a premium for their services.",
      },
      {
        num: "07",
        title: "Post-Transplant Care",
        desc: "Comprehensive post-transplant care and support are essential for optimal results. Clinics that offer tailored aftercare packages, including follow-up appointments and guidance, may have slightly higher costs that reflect the quality of service provided.",
      },
    ],
    topSurgeons: {
      heading: "Top 5 Hair Transplant Surgeons in India",
      list: [
        { name: "Dr. Rajesh Rajput",  city: "Mumbai",  href: null },
        { name: "Dr. Pradeep Sethi",  city: "Gurgaon", href: null },
        { name: "Dr. Ajinkya Patil", city: "Pune", href: "/description.php", highlight: true },
        { name: "Dr. Vikas Panthri",  city: "Delhi",   href: null },
        { name: "Dr. Manoj Khanna",   city: "Kolkata",  href: null },
      ],
    },
  },

  /* ── SECTION 4 Methods & Costs ── */
  methodsCost: {
    eyebrow: "Technique-wise Pricing",
    heading: "Hair Transplant Methods and Their Costs in Pune",
    intro: "Are you considering a hair transplant in Pune and wondering about the various methods available along with their associated costs? At Clinique Internationale, we understand the importance of making an informed decision, and we're here to guide you through the different hair transplant methods and their respective pricing.",
    fue: {
      title: "Follicular Unit Extraction (FUE)",
      href: "https://hairclinique.in/follicular-unit-extraction.php",
      desc: "FUE is a cutting-edge hair transplant technique known for its precision and minimally invasive nature. During an FUE procedure, individual hair follicles are extracted from the donor area and transplanted to the recipient area. This method leaves minimal scarring and offers a quicker recovery time compared to traditional methods.",
      heads: ["Stage of Baldness", "Number of Grafts Required", "Cost of FUE Hair Transplant"],
      rows: [
        { stage: "Stage 2", grafts: "500–1,500 Grafts",   cost: "₹40,000 to ₹60,000"   },
        { stage: "Stage 3", grafts: "1,500–2,000 Grafts", cost: "₹60,000 to ₹80,000"   },
        { stage: "Stage 4", grafts: "2,000–2,500 Grafts", cost: "₹80,000 to ₹1,20,000" },
        { stage: "Stage 5", grafts: "2,800–3,200 Grafts", cost: "₹1,20,000 to ₹2,00,000" },
      ],
    },
    fut: {
      title: "Follicular Unit Transplantation (FUT)",
      href: "https://hairclinique.in/follicular-unit-transplant.php",
      desc: "FUT, also known as the strip method, involves the removal of a strip of scalp from the donor area. This strip is then dissected into individual grafts for transplantation. FUT is known for its high graft yield and is particularly suitable for individuals requiring a larger number of grafts.",
      heads: ["FUT Session", "Average Number of Grafts", "Cost of FUT Hair Transplant"],
      rows: [
        { session: "Small Session",  grafts: "Up to 1,000", cost: "₹60,000"   },
        { session: "Medium Session", grafts: "Up to 2,000", cost: "₹80,000"   },
        { session: "Large Session",  grafts: "Up to 3,000", cost: "₹1,50,000" },
      ],
    },
  },

  /* ── SECTION 5 Why Clinique is Cost Effective ── */
  whyClinique: {
    eyebrow: "Why Choose Us",
    heading: "Why Clinique Internationale, Pune is Cost-Effective for Hair Transplant",
    intro: "When it comes to undergoing a hair transplant procedure in Pune, cost-effectiveness is a key consideration for many individuals. At Clinique Internationale, we take pride in offering exceptional hair transplant services that are not only of high quality but also cost-effective.",
    points: [
      {
        num: "01",
        title: "Expertise and Reputation",
        desc: "Clinique Internationale boasts a team of highly experienced and skilled medical professionals who specialise in hair transplant procedures. Our surgeons have a proven track record of delivering successful outcomes, ensuring that you receive the best possible care without compromising on quality.",
      },
      {
        num: "02",
        title: "Advanced Technique",
        desc: "We utilise cutting-edge hair transplant techniques, including Follicular Unit Extraction (FUE) and Follicular Unit Transplantation (FUT). Our advanced techniques not only ensure superior results but also minimise the invasiveness of the procedure.",
      },
      {
        num: "03",
        title: "Personalised Treatment Plans",
        desc: "At Clinique Internationale, we understand that every individual's hair loss situation is unique. Our approach involves creating personalised treatment plans tailored to your specific needs, so you pay only for what is truly required.",
      },
      {
        num: "04",
        title: "Transparent Pricing",
        desc: "We believe in transparency and clarity when it comes to our pricing structure. Our patients are provided with comprehensive information about all costs associated with the hair transplant procedure with no hidden fees.",
      },
      {
        num: "05",
        title: "Proven Results",
        desc: "Clinique Internationale's reputation is built on the foundation of proven results and patient satisfaction. We believe that delivering outstanding outcomes is the most cost-effective approach in the long run, as satisfied patients often become our strongest advocates.",
      },
    ],
  },

  /* ── CTA ── */
  cta: {
    eyebrow: "Get Started",
    heading: "Plan Your Hair Transplant Today",
    sub: "Book a personalised consultation with our specialists at our Pune centre. Get an accurate graft count, cost estimate and treatment plan all in one visit.",
    primary:   { label: "Book Consultation", href: "https://wa.me/919082123009?text=Hello!%20I%27m%20interested%20in%20learning%20more%20about%20your%20hair%20transplant%20services." },
    secondary: { label: "View All Treatments", href: "/about-hair-transplants.php" },
  },
};

/* ============================================================
   REUSABLE SUB-COMPONENTS
============================================================ */
function Eyebrow({ children, light = false }) {
  return (
    <p style={cinzel} className={`text-[10.5px] tracking-[0.28em] uppercase mb-3 flex items-center justify-center gap-2.5 ${light ? "text-[#c9a84c]/70" : "text-[#a07828]"}`}>
      <span className={`w-6 h-px ${light ? "bg-[#c9a84c]/50" : "bg-[#c9a84c]"}`} />
      {children}
    </p>
  );
}

function SectionHeading({ children, light = false, left = false }) {
  return (
    <h2 style={cinzel} className={`font-black text-[1.3rem] sm:text-[1.6rem] md:text-[1.85rem] uppercase tracking-[0.05em] mb-8 ${light ? "text-white" : "text-[#1a0f02]"} ${left ? "text-left" : "text-center"}`}>
      {children}
    </h2>
  );
}

function GoldDivider() {
  return <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/30 to-transparent" />;
}

function StyledTable({ heads, children }) {
  return (
    <div className="overflow-x-auto rounded-2xl border border-[#c9a84c]/20 shadow-[0_4px_24px_rgba(90,60,10,0.07)]">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-[#0e0905]">
            {heads.map((h) => (
              <th key={h} style={cinzel} className="text-left text-[11px] tracking-[0.1em] uppercase text-[#c9a84c] px-5 py-4 font-bold whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

function TableRow({ cells, i }) {
  return (
    <tr className={`border-t border-[#c9a84c]/10 ${i % 2 === 0 ? "bg-white" : "bg-[#f2ece0]/60"} hover:bg-[#c9a84c]/[0.05] transition-colors`}>
      {cells.map((c, j) => (
        <td key={j} className={`px-5 py-4 text-[13px] ${j === 0 ? "font-semibold text-[#1a0f02]" : "text-[#3a2e1e]"}`}>{c}</td>
      ))}
    </tr>
  );
}

/* ============================================================
   PAGE COMPONENT
============================================================ */
export default function HairTransplantCostInIndiaPune() {
  const pageRef     = useRef(null);
  const heroEyeRef  = useRef(null);
  const heroHeadRef = useRef(null);
  const heroSubRef  = useRef(null);
  const sectionRefs = useRef([]);
  const addRef      = (el) => el && !sectionRefs.current.includes(el) && sectionRefs.current.push(el);

// --- slider additions ---
const slideRefs = useRef([]);
const addSlideRef = (el) => el && !slideRefs.current.includes(el) && slideRefs.current.push(el);

useEffect(() => {
  const ctx = gsap.context(() => {
    const ease = "power3.out";
    gsap.fromTo(heroEyeRef.current,  { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7, ease });
    gsap.fromTo(heroHeadRef.current, { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 0.75, ease, delay: 0.1 });
    gsap.fromTo(heroSubRef.current,  { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.7, ease, delay: 0.18 });

    // --- slider crossfade loop ---
    gsap.set(slideRefs.current, { opacity: 0 });
    gsap.set(slideRefs.current[0], { opacity: 1 });

    const tl = gsap.timeline({ repeat: -1 });
    heroSlides.forEach((_, i) => {
      const next = (i + 1) % heroSlides.length;
      tl.to(slideRefs.current[i], { opacity: 0, duration: 1.2, ease: "power2.inOut" }, `+=3.5`)
        .to(slideRefs.current[next], { opacity: 1, duration: 1.2, ease: "power2.inOut" }, "<");
    });

    sectionRefs.current.forEach((el) => {
      if (!el) return;
      gsap.fromTo(el, { opacity: 0, y: 36 }, {
        opacity: 1, y: 0, duration: 0.75, ease: "power3.out",
        scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none reverse" },
      });
    });
  }, pageRef);
  return () => ctx.revert();
}, []);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const ease = "power3.out";
      gsap.fromTo(heroEyeRef.current,  { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7, ease });
      gsap.fromTo(heroHeadRef.current, { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 0.75, ease, delay: 0.1 });
      gsap.fromTo(heroSubRef.current,  { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.7, ease, delay: 0.18 });
      sectionRefs.current.forEach((el) => {
        if (!el) return;
        gsap.fromTo(el, { opacity: 0, y: 36 }, {
          opacity: 1, y: 0, duration: 0.75, ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none reverse" },
        });
      });
    }, pageRef);
    return () => ctx.revert();
  }, []);

  const wrap = "max-w-6xl mx-auto px-5 sm:px-8 lg:px-12";
  const sec  = "py-16 sm:py-20 md:py-24";

  return (
    <>
    <SEO
  title="Hair Transplant Cost in Pune | Clinique Internationale"
  description="Explore hair transplant cost in Pune at Clinique Internationale, led by Dr. Ajinkya Patil. Transparent pricing for FUE, FUT, and advanced hair restoration."
  url="https://pune.hairclinique.in/hair-transplant-cost-in-pune.php"
/>
      <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Raleway:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap" rel="stylesheet" />

      <div ref={pageRef} className="relative w-full bg-[#f2ece0] overflow-hidden mt-16 lg:mt-20" style={{ fontFamily: "'Raleway', sans-serif" }}>

  {/* ══════════════════════════════════════
      HERO
  ══════════════════════════════════════ */}
  <div className="relative h-[200px] xs:h-[280px] sm:h-[340px] md:h-[800px] flex items-center justify-end overflow-hidden">
    {heroSlides.map((src, i) => (
      <img
        key={i}
        ref={addSlideRef}
        className="absolute inset-0 w-full h-full object-cover object-[center_25%]"
        src={src}
        alt={`${PAGE.hero.heading} ${i + 1}`}
      />
    ))}
    <div className="absolute inset-0" />
    <div className="absolute inset-0 opacity-40 pointer-events-none"
      style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E\")" }}
    />
  </div>

        {/* BREADCRUMB */}
        <div className="bg-[#0e0905]/95 border-b border-[#c9a84c]/10">
          <div className={`${wrap} py-3 flex flex-wrap items-center gap-2`}>
            {PAGE.breadcrumb.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span className="text-[#c9a84c]/30 text-xs">›</span>}
                {b.href
                  ? <a href={b.href} style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]/60 hover:text-[#c9a84c] transition-colors">{b.label}</a>
                  : <span style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]">{b.label}</span>}
              </span>
            ))}
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 1 WHAT IS HAIR TRANSPLANT
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef} className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-start">
            {/* text */}
            <div>
              <Eyebrow>{PAGE.whatIs.eyebrow}</Eyebrow>
              <SectionHeading left>{PAGE.whatIs.heading}</SectionHeading>
              {PAGE.whatIs.paragraphs.map((p, i) => (
                <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] mb-4">{p}</p>
              ))}
            </div>
            {/* stats */}
            <div className="relative overflow-hidden bg-[#0e0905] border border-[#c9a84c]/20 rounded-2xl p-7 md:mt-14">
              <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/50 to-transparent" />
              <p style={cinzel} className="text-[10px] tracking-[0.22em] uppercase text-[#c9a84c]/60 mb-5">Quick Numbers</p>
              <div className="grid grid-cols-2 gap-6">
                {PAGE.whatIs.stats.map((s) => (
                  <div key={s.val}>
                    <div style={cinzel} className="font-black text-[1.55rem] leading-none mb-1 bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">{s.val}</div>
                    <div className="text-[11.5px] text-white/45 leading-snug">{s.sub}</div>
                  </div>
                ))}
              </div>
              <span className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/20 to-transparent" />
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 2 CITY-WISE COST TABLE
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow>{PAGE.cityTable.eyebrow}</Eyebrow>
              <SectionHeading>{PAGE.cityTable.heading}</SectionHeading>
              {PAGE.cityTable.intro.map((p, i) => (
                <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-4">{p}</p>
              ))}
              <div className="mt-8 max-w-3xl mx-auto">
                <StyledTable heads={PAGE.cityTable.heads}>
                  {PAGE.cityTable.rows.map((r, i) => (
                    <TableRow key={i} i={i} cells={[
                      r.city,
                      <span key="cost">
                        <span className="font-bold text-[#1a0f02]">{r.cost}</span>
                        <span className="block text-[11.5px] text-[#6b5535] mt-0.5">({r.per})</span>
                      </span>,
                    ]} />
                  ))}
                </StyledTable>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            SECTION 3 FACTORS (with Top 5 surgeons)
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <Eyebrow>{PAGE.factors.eyebrow}</Eyebrow>
            <SectionHeading>{PAGE.factors.heading}</SectionHeading>
            <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-10">{PAGE.factors.intro}</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12">
              {PAGE.factors.list.map((f) => (
                <div key={f.num} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 relative overflow-hidden hover:-translate-y-1 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300">
                  <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                  <div className="flex gap-4 items-start">
                    <span style={cinzel} className="font-black text-[2rem] leading-none text-[#c9a84c]/20 select-none flex-shrink-0">{f.num}</span>
                    <div>
                      <div style={cinzel} className="text-[13px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] mb-2">{f.title}</div>
                      <p className="text-[13.5px] leading-[1.8] text-[#6b5535]">{f.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Top 5 Surgeons */}
            <div className="relative overflow-hidden bg-[#0e0905] border border-[#c9a84c]/20 rounded-2xl p-8 sm:p-10">
              <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/50 to-transparent" />
              <Eyebrow light>Rankings</Eyebrow>
              <h3 style={cinzel} className="font-black text-[1.2rem] sm:text-[1.4rem] text-center text-white uppercase tracking-[0.06em] mb-8">
                {PAGE.factors.topSurgeons.heading}
              </h3>
              <div className="flex flex-col gap-3 max-w-lg mx-auto">
                {PAGE.factors.topSurgeons.list.map((s, i) => (
                  <div key={i} className={`flex items-center gap-4 rounded-xl px-5 py-4 border transition-colors ${s.highlight ? "bg-[#c9a84c]/[0.12] border-[#c9a84c]/35" : "bg-white/[0.04] border-white/10 hover:border-[#c9a84c]/20"}`}>
                    <div style={cinzel} className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-black text-[12px] ${s.highlight ? "bg-[#c9a84c] text-[#0e0905]" : "bg-white/10 text-white/50"}`}>
                      {String(i + 1).padStart(2, "0")}
                    </div>
                    <div className="flex-1">
                      {s.href
                        ? <a href={s.href} style={cinzel} className={`text-[13px] font-bold tracking-wide hover:text-[#ffe9a0] transition-colors ${s.highlight ? "text-[#ffe9a0]" : "text-white/85"}`}>{s.name}</a>
                        : <span style={cinzel} className="text-[13px] font-bold tracking-wide text-white/75">{s.name}</span>}
                    </div>
                    <span style={cinzel} className={`text-[10px] tracking-widest uppercase ${s.highlight ? "text-[#c9a84c]" : "text-white/35"}`}>{s.city}</span>
                  </div>
                ))}
              </div>
              <span className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/20 to-transparent" />
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 4 METHODS & COST TABLES
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow light>{PAGE.methodsCost.eyebrow}</Eyebrow>
              <SectionHeading light>{PAGE.methodsCost.heading}</SectionHeading>
              <p className="text-[14.5px] leading-[1.85] text-white/60 max-w-3xl mx-auto text-center mb-12">{PAGE.methodsCost.intro}</p>

              {/* FUE */}
              <div className="mb-12">
                <div className="flex items-center gap-3 mb-4">
                  <span className="w-1 h-8 rounded-full bg-[#c9a84c]" />
                  <a href={PAGE.methodsCost.fue.href} style={cinzel} className="text-[1rem] sm:text-[1.15rem] font-bold uppercase tracking-[0.06em] text-[#c9a84c] hover:text-[#ffe9a0] transition-colors">
                    {PAGE.methodsCost.fue.title}
                  </a>
                </div>
                <p className="text-[14px] leading-[1.85] text-white/60 mb-6">{PAGE.methodsCost.fue.desc}</p>
                <StyledTable heads={PAGE.methodsCost.fue.heads}>
                  {PAGE.methodsCost.fue.rows.map((r, i) => (
                    <tr key={i} className={`border-t border-[#c9a84c]/10 ${i % 2 === 0 ? "bg-white/[0.03]" : "bg-white/[0.06]"} hover:bg-[#c9a84c]/[0.08] transition-colors`}>
                      <td className="px-5 py-4 text-[13px] font-semibold text-white/85">{r.stage}</td>
                      <td className="px-5 py-4 text-[13px] text-white/60">{r.grafts}</td>
                      <td className="px-5 py-4 text-[13px] font-bold text-[#c9a84c]">{r.cost}</td>
                    </tr>
                  ))}
                </StyledTable>
              </div>

              {/* FUT */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <span className="w-1 h-8 rounded-full bg-[#c9a84c]" />
                  <a href={PAGE.methodsCost.fut.href} style={cinzel} className="text-[1rem] sm:text-[1.15rem] font-bold uppercase tracking-[0.06em] text-[#c9a84c] hover:text-[#ffe9a0] transition-colors">
                    {PAGE.methodsCost.fut.title}
                  </a>
                </div>
                <p className="text-[14px] leading-[1.85] text-white/60 mb-6">{PAGE.methodsCost.fut.desc}</p>
                <StyledTable heads={PAGE.methodsCost.fut.heads}>
                  {PAGE.methodsCost.fut.rows.map((r, i) => (
                    <tr key={i} className={`border-t border-[#c9a84c]/10 ${i % 2 === 0 ? "bg-white/[0.03]" : "bg-white/[0.06]"} hover:bg-[#c9a84c]/[0.08] transition-colors`}>
                      <td className="px-5 py-4 text-[13px] font-semibold text-white/85">{r.session}</td>
                      <td className="px-5 py-4 text-[13px] text-white/60">{r.grafts}</td>
                      <td className="px-5 py-4 text-[13px] font-bold text-[#c9a84c]">{r.cost}</td>
                    </tr>
                  ))}
                </StyledTable>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            SECTION 5 WHY CLINIQUE IS COST EFFECTIVE
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <Eyebrow>{PAGE.whyClinique.eyebrow}</Eyebrow>
            <SectionHeading>{PAGE.whyClinique.heading}</SectionHeading>
            <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-10">{PAGE.whyClinique.intro}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
              {PAGE.whyClinique.points.map((p) => (
                <div key={p.num} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 relative overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300">
                  <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a84c]/15 to-[#c9a84c]/[0.03] border border-[#c9a84c]/20 flex items-center justify-center mb-4">
                    <span style={cinzel} className="text-[11px] font-black text-[#c9a84c]">{p.num}</span>
                  </div>
                  <div style={cinzel} className="text-[12.5px] font-bold tracking-[0.06em] uppercase text-[#1a0f02] mb-2.5">{p.title}</div>
                  <p className="text-[13px] leading-[1.75] text-[#6b5535]">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            MISSION STRIP
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0e0905] py-14 sm:py-16">
          <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
            <p style={cinzel} className="text-[1rem] sm:text-[1.2rem] md:text-[1.35rem] font-light leading-[1.7] text-white/85 tracking-[0.02em]">
              "We believe that every patient deserves{" "}
              <em className="italic" style={{ color: "#c9a84c" }}>world-class hair restoration</em>{" "}
              at a price that is honest, transparent and accessible because great results shouldn't come at the cost of trust."
            </p>
            <p className="text-[11px] tracking-[0.18em] uppercase text-[#c9a84c]/50 mt-5">
             Dr. Ajinkya Patil, Lead Surgeon · Clinique Internationale, Pune
            </p>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            CTA
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef} className="max-w-xl mx-auto text-center">
            <Eyebrow>{PAGE.cta.eyebrow}</Eyebrow>
            <h3 style={cinzel} className="font-black text-[1.3rem] sm:text-[1.65rem] md:text-[1.9rem] text-[#1a0f02] uppercase tracking-[0.06em] mb-3.5">
              {PAGE.cta.heading}
            </h3>
            <p className="text-[14px] text-[#6b5535] leading-[1.75] mb-8">{PAGE.cta.sub}</p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a href={PAGE.cta.primary.href}
                style={{ ...cinzel, backgroundImage: "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)", backgroundSize: "200% 100%" }}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-3.5 rounded-md text-[#1a0f02] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(201,168,76,0.35)] transition-all inline-block">
                {PAGE.cta.primary.label}
              </a>
              <a href={PAGE.cta.secondary.href}
                style={cinzel}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-[13px] rounded-md bg-transparent border border-[#1a0f02]/35 text-[#1a0f02] hover:-translate-y-0.5 hover:border-[#c9a84c] hover:text-[#a07828] transition-all inline-block">
                {PAGE.cta.secondary.label}
              </a>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}